var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacetime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Facetime"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 38",
    x: 0.75,
    y: 5.25,
    width: 17.5,
    height: 15.5,
    rx: 3.25,
    stroke: "#3478F6",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M18.6001 13.6682C18.2588 13.2881 18.2588 12.7119 18.6001 12.3318L23.256 7.14766C23.8687 6.46542 25 6.89885 25 7.81584L25 18.1842C25 19.1012 23.8687 19.5346 23.256 18.8524L18.6001 13.6682Z",
    stroke: "#3478F6",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacetime);
export default __webpack_public_path__ + "static/media/Facetime.37d30000b3142fd1c8e725d6ce848ddf.svg";
export { ForwardRef as ReactComponent };